// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================================
   Account/Settings Page - Flat Design System
   Uses CSS variables from colors.css
   =================================== */

.account-content {
  max-width: 720px;
  margin: 0 auto;
  padding: clamp(24px, 4vh, 40px) clamp(20px, 4vw, 32px);
  min-height: 100%;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
}

.account-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: clamp(28px, 4vw, 36px);
  font-weight: 400;
  color: var(--color-text-primary);
  margin: 0 0 28px 0;
}

/* ===================================
   Section Styles
   =================================== */

.account-section {
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 2px;
  padding: 16px;
  margin-bottom: 16px;
}

.account-org-section {
  scroll-margin-top: 24px;
}

.account-section-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-text-secondary);
  margin: 0 0 14px 0;
}

.account-billing-readonly {
  margin: -4px 0 14px;
  color: var(--color-text-secondary);
  font-size: 12px;
  line-height: 1.45;
}

/* ===================================
   Info Rows
   =================================== */

.account-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid var(--color-border-input);
}

.account-info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.account-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-secondary);
}

.account-value {
  font-size: 13px;
  color: var(--color-text-primary);
}

/* ===================================
   Usage Section
   =================================== */

.account-usage-loading,
.account-usage-error {
  padding: 16px 0;
  text-align: center;
  color: var(--color-text-secondary);
  font-size: 13px;
}

.account-usage-error {
  color: #c0392b;
}

.account-usage-empty {
  padding: 16px 0;
  text-align: center;
}

.account-usage-empty p {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 13px;
}

.account-usage-hint {
  margin-top: 6px !important;
  font-size: 12px !important;
  color: var(--color-text-secondary) !important;
  opacity: 0.7;
}

/* ===================================
   Usage Amount Display
   =================================== */

.account-usage-amount {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 24px;
  border-bottom: 1px solid var(--color-border-input);
  margin-bottom: 12px;
}

.account-usage-value {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 36px;
  font-weight: 400;
  color: var(--color-text-primary);
  line-height: 1;
}

.account-usage-label {
  margin-top: 6px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-text-secondary);
}

/* ===================================
   Daily Usage Chart - Flat Design
   =================================== */

.account-chart {
  padding: 8px 0;
}

.account-chart-bars {
  display: flex;
  align-items: flex-end;
  gap: 2px;
  height: 120px;
  padding-bottom: 24px;
  position: relative;
}

.account-chart-bar-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  position: relative;
}

.account-chart-bar {
  width: 100%;
  max-width: 20px;
  min-height: 2px;
  background: var(--color-text-secondary);
  border-radius: 2px 2px 0 0;
  margin-top: auto;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.account-chart-bar:hover {
  opacity: 0.7;
}

.account-chart-bar-empty {
  background: var(--color-border-input);
  min-height: 2px;
}

.account-chart-bar-skeleton {
  background: var(--color-bg-input);
  animation: shimmer 1.5s ease-in-out infinite;
  border-radius: 2px 2px 0 0;
}

@keyframes shimmer {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.8;
  }
}

.account-chart-label {
  position: absolute;
  bottom: -20px;
  font-size: 9px;
  font-weight: 500;
  color: var(--color-text-secondary);
  white-space: nowrap;
  text-align: center;
}

/* ===================================
   Chart Tooltip
   =================================== */

.account-chart-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 6px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  color: var(--color-text-primary);
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  pointer-events: none;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.account-chart-tooltip::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--color-border-input);
}

/* ===================================
   Organization Section
   =================================== */

.account-org-section { padding: 0; overflow: hidden; }

.account-org-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  border-bottom: 1px solid var(--color-border-input);
}

.account-org-heading .account-section-title { margin-bottom: 4px; }

.account-org-heading p {
  max-width: 510px;
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 12px;
  line-height: 1.45;
}

.account-org-count {
  flex: 0 0 auto;
  color: var(--color-text-secondary);
  font-size: 11px;
  font-variant-numeric: tabular-nums;
}

.account-org-identity {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--color-border-input);
}

.account-org-avatar,
.account-org-person-avatar {
  display: grid;
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  place-items: center;
  border: 1px solid var(--color-border-input);
  border-radius: 5px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 600;
}

.account-org-avatar {
  overflow: hidden;
}

.account-org-avatar img {
  width: 100%;
  height: 100%;
  padding: 4px;
  object-fit: contain;
  background: #ffffff;
}

.account-org-identity-copy { min-width: 0; flex: 1 1; }

.account-org-identity-copy > span {
  display: block;
  margin-bottom: 2px;
  color: var(--color-text-secondary);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.account-org-name-display {
  display: flex;
  align-items: center;
  gap: 8px;
}

.account-org-name-display strong { font-size: 13px; font-weight: 550; }

.account-org-name-edit-btn,
.account-org-text-action,
.account-org-confirm button {
  padding: 2px 6px;
  border: 0;
  background: transparent;
  color: var(--color-text-secondary);
  font: inherit;
  font-size: 11px;
  cursor: pointer;
}

.account-org-name-edit-btn:hover,
.account-org-text-action:hover,
.account-org-confirm button:hover { color: var(--color-text-primary); }

.account-org-name-edit { display: flex; align-items: center; gap: 5px; }

.account-org-name-edit input,
.account-org-invite input {
  min-width: 0;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  outline: 0;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font: inherit;
  font-size: 12px;
}

.account-org-name-edit input { height: 30px; padding: 0 8px; }

.account-org-name-edit input:focus,
.account-org-invite input:focus { border-color: var(--color-text-secondary); }

.account-org-name-save,
.account-org-name-cancel,
.account-org-invite button,
.account-org-load-error button {
  height: 30px;
  padding: 0 9px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font: inherit;
  font-size: 11px;
  font-weight: 550;
  cursor: pointer;
}

.account-org-name-save:disabled,
.account-org-name-cancel:disabled,
.account-org-invite button:disabled { opacity: .5; cursor: default; }

.account-org-role {
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 0 6px;
  border: 1px solid var(--color-border-input);
  border-radius: 3px;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 9px;
  font-weight: 600;
  letter-spacing: .05em;
  text-transform: uppercase;
}

.account-org-role--pending { color: var(--color-text-primary); }
.account-org-role--expired,
.account-org-role--revoked { opacity: .68; }

.account-org-invite-panel {
  display: grid;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--color-border-input);
  background: color-mix(in srgb, var(--color-bg-input) 52%, transparent);
}

.account-org-invite-panel > div { display: grid; gap: 2px; }
.account-org-invite-panel strong { font-size: 12px; font-weight: 550; }
.account-org-invite-panel span { color: var(--color-text-secondary); font-size: 11px; }

.account-org-invite { display: flex; gap: 7px; }
.account-org-invite input { height: 34px; flex: 1 1; padding: 0 10px; }
.account-org-invite button { height: 34px; white-space: nowrap; }
.account-org-invite button:hover:not(:disabled),
.account-org-load-error button:hover { background: var(--color-bg-user-bubble); }

.account-org-message,
.account-org-load-error {
  margin: 12px 16px 0;
  padding: 9px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 11px;
  line-height: 1.4;
}

.account-org-message--error { border-color: rgba(192, 57, 43, .4); color: #d98d82; }
.account-org-message--success { border-color: rgba(77, 146, 102, .4); color: #8fc9a4; }

.account-org-load-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.account-org-list { padding: 14px 16px 0; }
.account-org-list:last-child { padding-bottom: 8px; }

.account-org-list-title {
  margin-bottom: 6px;
  color: var(--color-text-secondary);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: .05em;
  text-transform: uppercase;
}

.account-org-list-row {
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-bottom: 1px solid var(--color-border-input);
}

.account-org-list-row:last-child { border-bottom: 0; }

.account-org-person { display: flex; min-width: 0; align-items: center; gap: 9px; }
.account-org-person-avatar { width: 26px; height: 26px; border-radius: 50%; font-size: 10px; }
.account-org-person-avatar--invite { color: var(--color-text-secondary); }
.account-org-person > div:last-child { display: grid; min-width: 0; gap: 1px; }
.account-org-person strong { overflow: hidden; font-size: 12px; font-weight: 520; text-overflow: ellipsis; white-space: nowrap; }
.account-org-person span { color: var(--color-text-secondary); font-size: 10px; }

.account-org-row-actions { display: flex; flex: 0 0 auto; align-items: center; gap: 3px; }
.account-org-text-action--danger:hover { color: #d98d82; }
.account-org-text-action:disabled { opacity: .5; cursor: wait; }

.account-org-confirm { display: flex; align-items: center; gap: 1px; }
.account-org-confirm > span { margin-right: 2px; color: #d98d82; font-size: 10px; }
.account-org-confirm button:first-of-type { color: #d98d82; }

@media (max-width: 560px) {
  .account-org-heading { align-items: center; }
  .account-org-heading p { display: none; }
  .account-org-invite { flex-direction: column; }
  .account-org-invite button { width: 100%; }
  .account-org-list-row { align-items: flex-start; flex-direction: column; gap: 7px; padding: 9px 0; }
  .account-org-row-actions { width: 100%; justify-content: flex-end; }
  .account-org-name-edit { flex-wrap: wrap; }
}

.account-usage-note {
  text-align: center;
  font-size: 12px;
  color: var(--color-text-secondary);
  margin-bottom: 12px;
}

.account-usage-info-banner {
  font-size: 12px;
  color: var(--color-text-secondary);
  background: var(--color-bg-secondary, rgba(255, 255, 255, 0.05));
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 12px;
  line-height: 1.4;
}

.account-chart-tooltip-date {
  font-size: 10px;
  color: var(--color-text-secondary);
}

.account-chart-tooltip-amount {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
}

/* ===================================
   Credits & Coupon Section
   =================================== */

.account-credits-balance {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 24px;
  border-bottom: 1px solid var(--color-border-input);
  margin-bottom: 14px;
}

.account-credits-value {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 36px;
  font-weight: 400;
  color: var(--color-text-primary);
  line-height: 1;
}

.account-credits-label {
  margin-top: 6px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-text-secondary);
}

.account-coupon-form {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.account-coupon-form input {
  flex: 1 1;
  padding: 10px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 2px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-family: inherit;
  letter-spacing: 0.08em;
  transition: border-color 0.15s ease;
}

.account-coupon-form input:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.account-coupon-form input::placeholder {
  color: var(--color-text-secondary);
  letter-spacing: normal;
}

.account-coupon-form input:disabled {
  opacity: 0.5;
}

.account-coupon-form button {
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 2px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease;
  white-space: nowrap;
}

.account-coupon-form button:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.account-coupon-form button:disabled {
  opacity: 0.5;
  cursor: default;
}

.account-coupon-message {
  margin-top: 10px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 2px;
}

.account-coupon-message-success {
  color: var(--color-text-primary);
  background: var(--color-bg-user-bubble);
  border: 1px solid var(--color-border-input);
}

.account-coupon-message-error {
  color: var(--color-status-error-text);
  background: var(--color-status-error-tint);
  border: 1px solid var(--color-status-error-border);
}

/* ===================================
   Payment Method Modal
   =================================== */

.account-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 2100;
}

.account-modal-card {
  width: min(420px, 100%);
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: accountModalIn 0.15s ease;
}

@keyframes accountModalIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.account-modal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--color-text-primary);
  text-align: center;
}

.account-modal-desc {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--color-text-secondary);
  text-align: center;
}

.account-modal-desc strong {
  color: var(--color-text-primary);
  font-weight: 600;
}

.account-modal-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;
}

.account-modal-primary,
.account-modal-secondary {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 2px;
  font-family: inherit;
  font-size: 14px;
  cursor: pointer;
  transition: filter 0.15s ease, background 0.15s ease;
}

.account-modal-primary {
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
  font-weight: 600;
}

.account-modal-primary:hover:not(:disabled) {
  filter: brightness(0.96);
}

.account-modal-primary:disabled {
  opacity: 0.6;
  cursor: default;
}

.account-modal-secondary {
  background: transparent;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.account-modal-secondary:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.account-modal-secondary:disabled {
  opacity: 0.5;
  cursor: default;
}

/* Credits Actions Row */
.account-credits-actions-row {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

.account-credits-buy-btn {
  padding: 8px 16px;
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
  border: 1px solid var(--color-accent-base);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.account-credits-buy-btn:hover {
  filter: brightness(0.96);
}

/* Auto-Reload Settings */
.account-auto-reload {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--color-border-input);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.account-auto-reload-toggle {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.account-toggle-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--color-text-primary);
  cursor: pointer;
}

.account-toggle-label input[type="checkbox"] {
  accent-color: var(--color-accent-base);
}

.account-auto-reload-desc {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin-left: 24px;
}

.account-auto-reload-config {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 24px;
}

.account-auto-reload-select {
  padding: 4px 8px;
  font-family: inherit;
  font-size: 13px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  color: var(--color-text-primary);
}

/* Switch to Credits */
.account-switch-credits {
  border: 1px solid var(--color-border-input);
  padding: 16px;
}

.account-switch-desc {
  margin: 0 0 12px;
  font-size: 13px;
  color: var(--color-text-secondary);
  line-height: 1.45;
}

.account-switch-btn {
  padding: 8px 16px;
  background: transparent;
  color: var(--color-accent-base);
  border: 1px solid var(--color-accent-base);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.account-switch-btn:hover:not(:disabled) {
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
}

.account-switch-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Credit Purchase History */
.account-credit-history {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.account-credit-history-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid var(--color-border-input);
}

.account-credit-history-row:last-child {
  border-bottom: none;
}

.account-credit-history-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.account-credit-history-source {
  font-size: 13px;
  color: var(--color-text-primary);
  text-transform: capitalize;
}

.account-credit-history-date {
  font-size: 11px;
  color: var(--color-text-secondary);
}

.account-credit-history-amount {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
}

/* ===================================
   Email Preferences
   =================================== */

.account-email-pref-note {
  font-size: 13px;
  color: var(--color-text-secondary);
  line-height: 1.5;
  margin: 8px 0 0 0;
}

.account-email-pref-link {
  color: var(--color-text-primary);
  text-decoration: underline;
}

/* ===================================
   Referral Section
   =================================== */

.account-referral-desc {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0 0 16px;
  line-height: 1.5;
}

.account-referral-link-box {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.account-referral-link-input {
  flex: 1 1;
  padding: 10px 12px;
  font-size: 13px;
  border: 1px solid var(--color-border-input);
  border-radius: 2px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-family: monospace;
  cursor: text;
}

.account-referral-copy-btn {
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  border-radius: 2px;
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  cursor: pointer;
  white-space: nowrap;
  min-width: 72px;
}

.account-referral-copy-btn:hover {
  opacity: 0.85;
}

.account-referral-code-display {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin-bottom: 16px;
}

.account-referral-code-display strong {
  font-family: monospace;
  letter-spacing: 1px;
  color: var(--color-text-primary);
}

.account-referral-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
  padding: 12px 0;
  border-top: 1px solid var(--color-border-input);
  border-bottom: 1px solid var(--color-border-input);
}

.account-referral-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
}

.account-referral-stat-value {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.account-referral-stat-label {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin-top: 2px;
}

.account-referral-invite-form {
  display: flex;
  gap: 8px;
}

.account-referral-invite-form input {
  flex: 1 1;
  padding: 10px 12px;
  font-size: 13px;
  border: 1px solid var(--color-border-input);
  border-radius: 2px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-family: inherit;
}

.account-referral-invite-form input:focus {
  outline: none;
  border-color: var(--color-accent-base);
}

.account-referral-invite-form button {
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid var(--color-border-input);
  border-radius: 2px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  cursor: pointer;
  white-space: nowrap;
}

.account-referral-invite-form button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Subscription Plan Cards ── */
.subscription-plans {
  display: flex;
  gap: 12px;
  margin-top: 4px;
}

.subscription-plan-card {
  position: relative;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  padding: 20px 16px;
  background: var(--color-bg-canvas-surface);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.subscription-plan-card:hover {
  border-color: color-mix(in srgb, var(--color-accent-base) 50%, var(--color-border-input));
}

.subscription-plan-card--active {
  border-color: var(--color-accent-base);
  box-shadow: 0 0 0 1px var(--color-accent-base), 0 8px 28px -12px rgba(15, 18, 24, 0.5);
}

.subscription-plan-card__badge {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--color-accent-base);
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 2px 12px;
  border-radius: 20px;
  white-space: nowrap;
}

.subscription-plan-card__name {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0 0 4px;
}

.subscription-plan-card__price {
  display: flex;
  align-items: baseline;
  gap: 2px;
  margin-bottom: 12px;
}

.subscription-plan-card__amount {
  font-size: 28px;
  font-weight: 700;
  color: var(--color-text-primary);
  line-height: 1;
}

.subscription-plan-card__period {
  font-size: 12px;
  color: var(--color-text-secondary);
}

.subscription-plan-card__features {
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.subscription-plan-card__features li {
  font-size: 12px;
  color: var(--color-text-secondary);
  line-height: 1.4;
  padding-left: 16px;
  position: relative;
}

.subscription-plan-card__features li::before {
  content: "\\2713";
  position: absolute;
  left: 0;
  color: var(--color-accent-base);
  font-weight: 600;
  font-size: 11px;
}

.subscription-plan-card__features li strong {
  color: var(--color-text-primary);
}

.subscription-plan-card__action {
  display: block;
  width: 100%;
  text-align: center;
  padding: 9px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  border: none;
  transition: opacity 0.15s;
}

.subscription-plan-card__action:hover:not(:disabled) {
  opacity: 0.85;
}

.subscription-plan-card__action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.account-referral-badge {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 2px;
  font-weight: 500;
}

.account-referral-badge--pending {
  color: var(--color-text-secondary);
  background: var(--color-bg-input);
}

.account-referral-badge--credited {
  color: #15803d;
  background: rgba(21, 128, 61, 0.08);
}

.subscription-plan-card__action--primary {
  background: var(--color-accent-base);
  color: #fff;
}

.subscription-plan-card__action--current {
  background: color-mix(in srgb, var(--color-accent-base) 12%, transparent);
  color: var(--color-accent-base);
  border: 1px solid color-mix(in srgb, var(--color-accent-base) 30%, transparent);
  cursor: default;
}

.subscription-plan-card__action--secondary {
  background: transparent;
  border: 1px solid var(--color-border-input);
  color: var(--color-text-primary);
}

.subscription-plan-card__action--danger {
  background: transparent;
  border: 1px solid color-mix(in srgb, #c9302c 40%, var(--color-border-input));
  color: #c9302c;
  margin-top: 6px;
  font-weight: 500;
  font-size: 11px;
}

/* Active plan details inside card */
.subscription-plan-card__details {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
  padding: 10px;
  background: color-mix(in srgb, var(--color-accent-base) 5%, transparent);
  border: 1px solid color-mix(in srgb, var(--color-accent-base) 15%, transparent);
  border-radius: 6px;
}

.subscription-plan-card__detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
}

.subscription-plan-card__detail-label {
  color: var(--color-text-secondary);
}

.subscription-plan-card__detail-value {
  color: var(--color-text-primary);
  font-weight: 600;
}

.subscription-plan-card__allowance-bar {
  height: 6px;
  background: color-mix(in srgb, var(--color-accent-base) 12%, transparent);
  border-radius: 3px;
  overflow: hidden;
  margin-top: 2px;
}

.subscription-plan-card__allowance-fill {
  height: 100%;
  background: var(--color-accent-base);
  border-radius: 3px;
  transition: width 0.3s ease;
}

.subscription-plan-card__cancel-notice {
  font-size: 11px;
  color: #e5a000;
  text-align: center;
  margin-bottom: 8px;
}

@media (max-width: 600px) {
  .subscription-plans {
    flex-direction: column;
  }
}

.account-btn {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: opacity 0.15s;
}

.account-btn:hover {
  opacity: 0.85;
}

.account-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.account-btn--primary {
  background: var(--color-accent-base);
  color: #fff;
}

.account-btn--secondary {
  background: transparent;
  border: 1px solid var(--color-border-input);
  color: var(--color-text-primary);
}

.account-btn--danger {
  background: transparent;
  border: 1px solid #c9302c;
  color: #c9302c;
}
`, "",{"version":3,"sources":["webpack://./src/AccountPage.css"],"names":[],"mappings":"AAAA;;;wCAGwC;;AAExC;EACE,gBAAgB;EAChB,cAAc;EACd,sDAAsD;EACtD,gBAAgB;EAChB,gCAAgC;EAChC,8EAA8E;AAChF;;AAEA;EACE,mDAAmD;EACnD,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;wCAEwC;;AAExC;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;;wCAEwC;;AAExC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;;wCAEwC;;AAExC;;EAEE,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,6CAA6C;EAC7C,YAAY;AACd;;AAEA;;wCAEwC;;AAExC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;wCAEwC;;AAExC;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,uCAAuC;EACvC,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;wCAEwC;;AAExC;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;EAC3C,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;;wCAEwC;;AAExC,uBAAuB,UAAU,EAAE,gBAAgB,EAAE;;AAErD;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,kDAAkD;AACpD;;AAEA,8CAA8C,kBAAkB,EAAE;;AAElE;EACE,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,6BAA6B,YAAY,EAAE,SAAO,EAAE;;AAEpD;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mCAAmC,eAAe,EAAE,gBAAgB,EAAE;;AAEtE;;;EAGE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;;oCAEoC,gCAAgC,EAAE;;AAEtE,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAEvE;;EAEE,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,eAAe;AACjB;;AAEA,+BAA+B,YAAY,EAAE,cAAc,EAAE;;AAE7D;kCACkC,yCAAyC,EAAE;;AAE7E;;;;EAIE,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;sCAEsC,WAAW,EAAE,eAAe,EAAE;;AAEpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,6BAA6B,gCAAgC,EAAE;AAC/D;6BAC6B,YAAY,EAAE;;AAE3C;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kDAAkD;EAClD,sEAAsE;AACxE;;AAEA,kCAAkC,aAAa,EAAE,QAAQ,EAAE;AAC3D,mCAAmC,eAAe,EAAE,gBAAgB,EAAE;AACtE,iCAAiC,kCAAkC,EAAE,eAAe,EAAE;;AAEtF,sBAAsB,aAAa,EAAE,QAAQ,EAAE;AAC/C,4BAA4B,YAAY,EAAE,SAAO,EAAE,eAAe,EAAE;AACpE,6BAA6B,YAAY,EAAE,mBAAmB,EAAE;AAChE;uCACuC,uCAAuC,EAAE;;AAEhF;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA,8BAA8B,mCAAmC,EAAE,cAAc,EAAE;AACnF,gCAAgC,oCAAoC,EAAE,cAAc,EAAE;;AAEtF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,oBAAoB,oBAAoB,EAAE;AAC1C,+BAA+B,mBAAmB,EAAE;;AAEpD;EACE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kDAAkD;AACpD;;AAEA,mCAAmC,gBAAgB,EAAE;;AAErD,sBAAsB,aAAa,EAAE,YAAY,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAClF,6BAA6B,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC7F,qCAAqC,kCAAkC,EAAE;AACzE,uCAAuC,aAAa,EAAE,YAAY,EAAE,QAAQ,EAAE;AAC9E,6BAA6B,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAChI,2BAA2B,kCAAkC,EAAE,eAAe,EAAE;;AAEhF,2BAA2B,aAAa,EAAE,cAAc,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACzF,yCAAyC,cAAc,EAAE;AACzD,oCAAoC,WAAW,EAAE,YAAY,EAAE;;AAE/D,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACrE,8BAA8B,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;AAClF,4CAA4C,cAAc,EAAE;;AAE5D;EACE,uBAAuB,mBAAmB,EAAE;EAC5C,yBAAyB,aAAa,EAAE;EACxC,sBAAsB,sBAAsB,EAAE;EAC9C,6BAA6B,WAAW,EAAE;EAC1C,wBAAwB,uBAAuB,EAAE,sBAAsB,EAAE,QAAQ,EAAE,cAAc,EAAE;EACnG,2BAA2B,WAAW,EAAE,yBAAyB,EAAE;EACnE,yBAAyB,eAAe,EAAE;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gEAAgE;EAChE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;wCAEwC;;AAExC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;;wCAEwC;;AAExC;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;EAC1C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iCAAiC;EACjC,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;EAC/B,0CAA0C;EAC1C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;wCAEwC;;AAExC;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;;wCAEwC;;AAExC;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,sCAAsC;EACtC,sFAAsF;AACxF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,yEAAyE;EACzE,+BAA+B;EAC/B,+EAA+E;EAC/E,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,4EAA4E;EAC5E,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,wEAAwE;EACxE,+EAA+E;EAC/E,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yEAAyE;EACzE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":["/* ===================================\n   Account/Settings Page - Flat Design System\n   Uses CSS variables from colors.css\n   =================================== */\n\n.account-content {\n  max-width: 720px;\n  margin: 0 auto;\n  padding: clamp(24px, 4vh, 40px) clamp(20px, 4vw, 32px);\n  min-height: 100%;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n}\n\n.account-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: clamp(28px, 4vw, 36px);\n  font-weight: 400;\n  color: var(--color-text-primary);\n  margin: 0 0 28px 0;\n}\n\n/* ===================================\n   Section Styles\n   =================================== */\n\n.account-section {\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 2px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.account-org-section {\n  scroll-margin-top: 24px;\n}\n\n.account-section-title {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--color-text-secondary);\n  margin: 0 0 14px 0;\n}\n\n.account-billing-readonly {\n  margin: -4px 0 14px;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n/* ===================================\n   Info Rows\n   =================================== */\n\n.account-info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.account-info-row:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.account-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n}\n\n.account-value {\n  font-size: 13px;\n  color: var(--color-text-primary);\n}\n\n/* ===================================\n   Usage Section\n   =================================== */\n\n.account-usage-loading,\n.account-usage-error {\n  padding: 16px 0;\n  text-align: center;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n}\n\n.account-usage-error {\n  color: #c0392b;\n}\n\n.account-usage-empty {\n  padding: 16px 0;\n  text-align: center;\n}\n\n.account-usage-empty p {\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n}\n\n.account-usage-hint {\n  margin-top: 6px !important;\n  font-size: 12px !important;\n  color: var(--color-text-secondary) !important;\n  opacity: 0.7;\n}\n\n/* ===================================\n   Usage Amount Display\n   =================================== */\n\n.account-usage-amount {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 0 24px;\n  border-bottom: 1px solid var(--color-border-input);\n  margin-bottom: 12px;\n}\n\n.account-usage-value {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 36px;\n  font-weight: 400;\n  color: var(--color-text-primary);\n  line-height: 1;\n}\n\n.account-usage-label {\n  margin-top: 6px;\n  font-size: 11px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--color-text-secondary);\n}\n\n/* ===================================\n   Daily Usage Chart - Flat Design\n   =================================== */\n\n.account-chart {\n  padding: 8px 0;\n}\n\n.account-chart-bars {\n  display: flex;\n  align-items: flex-end;\n  gap: 2px;\n  height: 120px;\n  padding-bottom: 24px;\n  position: relative;\n}\n\n.account-chart-bar-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  position: relative;\n}\n\n.account-chart-bar {\n  width: 100%;\n  max-width: 20px;\n  min-height: 2px;\n  background: var(--color-text-secondary);\n  border-radius: 2px 2px 0 0;\n  margin-top: auto;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.account-chart-bar:hover {\n  opacity: 0.7;\n}\n\n.account-chart-bar-empty {\n  background: var(--color-border-input);\n  min-height: 2px;\n}\n\n.account-chart-bar-skeleton {\n  background: var(--color-bg-input);\n  animation: shimmer 1.5s ease-in-out infinite;\n  border-radius: 2px 2px 0 0;\n}\n\n@keyframes shimmer {\n  0%, 100% {\n    opacity: 0.5;\n  }\n  50% {\n    opacity: 0.8;\n  }\n}\n\n.account-chart-label {\n  position: absolute;\n  bottom: -20px;\n  font-size: 9px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  white-space: nowrap;\n  text-align: center;\n}\n\n/* ===================================\n   Chart Tooltip\n   =================================== */\n\n.account-chart-tooltip {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 6px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-primary);\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n\n.account-chart-tooltip::after {\n  content: '';\n  position: absolute;\n  bottom: -5px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid var(--color-border-input);\n}\n\n/* ===================================\n   Organization Section\n   =================================== */\n\n.account-org-section { padding: 0; overflow: hidden; }\n\n.account-org-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.account-org-heading .account-section-title { margin-bottom: 4px; }\n\n.account-org-heading p {\n  max-width: 510px;\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.account-org-count {\n  flex: 0 0 auto;\n  color: var(--color-text-secondary);\n  font-size: 11px;\n  font-variant-numeric: tabular-nums;\n}\n\n.account-org-identity {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.account-org-avatar,\n.account-org-person-avatar {\n  display: grid;\n  width: 30px;\n  height: 30px;\n  flex: 0 0 auto;\n  place-items: center;\n  border: 1px solid var(--color-border-input);\n  border-radius: 5px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.account-org-avatar {\n  overflow: hidden;\n}\n\n.account-org-avatar img {\n  width: 100%;\n  height: 100%;\n  padding: 4px;\n  object-fit: contain;\n  background: #ffffff;\n}\n\n.account-org-identity-copy { min-width: 0; flex: 1; }\n\n.account-org-identity-copy > span {\n  display: block;\n  margin-bottom: 2px;\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.account-org-name-display {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.account-org-name-display strong { font-size: 13px; font-weight: 550; }\n\n.account-org-name-edit-btn,\n.account-org-text-action,\n.account-org-confirm button {\n  padding: 2px 6px;\n  border: 0;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font: inherit;\n  font-size: 11px;\n  cursor: pointer;\n}\n\n.account-org-name-edit-btn:hover,\n.account-org-text-action:hover,\n.account-org-confirm button:hover { color: var(--color-text-primary); }\n\n.account-org-name-edit { display: flex; align-items: center; gap: 5px; }\n\n.account-org-name-edit input,\n.account-org-invite input {\n  min-width: 0;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  outline: 0;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font: inherit;\n  font-size: 12px;\n}\n\n.account-org-name-edit input { height: 30px; padding: 0 8px; }\n\n.account-org-name-edit input:focus,\n.account-org-invite input:focus { border-color: var(--color-text-secondary); }\n\n.account-org-name-save,\n.account-org-name-cancel,\n.account-org-invite button,\n.account-org-load-error button {\n  height: 30px;\n  padding: 0 9px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font: inherit;\n  font-size: 11px;\n  font-weight: 550;\n  cursor: pointer;\n}\n\n.account-org-name-save:disabled,\n.account-org-name-cancel:disabled,\n.account-org-invite button:disabled { opacity: .5; cursor: default; }\n\n.account-org-role {\n  display: inline-flex;\n  align-items: center;\n  min-height: 20px;\n  padding: 0 6px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 3px;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 9px;\n  font-weight: 600;\n  letter-spacing: .05em;\n  text-transform: uppercase;\n}\n\n.account-org-role--pending { color: var(--color-text-primary); }\n.account-org-role--expired,\n.account-org-role--revoked { opacity: .68; }\n\n.account-org-invite-panel {\n  display: grid;\n  gap: 10px;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--color-border-input);\n  background: color-mix(in srgb, var(--color-bg-input) 52%, transparent);\n}\n\n.account-org-invite-panel > div { display: grid; gap: 2px; }\n.account-org-invite-panel strong { font-size: 12px; font-weight: 550; }\n.account-org-invite-panel span { color: var(--color-text-secondary); font-size: 11px; }\n\n.account-org-invite { display: flex; gap: 7px; }\n.account-org-invite input { height: 34px; flex: 1; padding: 0 10px; }\n.account-org-invite button { height: 34px; white-space: nowrap; }\n.account-org-invite button:hover:not(:disabled),\n.account-org-load-error button:hover { background: var(--color-bg-user-bubble); }\n\n.account-org-message,\n.account-org-load-error {\n  margin: 12px 16px 0;\n  padding: 9px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n.account-org-message--error { border-color: rgba(192, 57, 43, .4); color: #d98d82; }\n.account-org-message--success { border-color: rgba(77, 146, 102, .4); color: #8fc9a4; }\n\n.account-org-load-error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.account-org-list { padding: 14px 16px 0; }\n.account-org-list:last-child { padding-bottom: 8px; }\n\n.account-org-list-title {\n  margin-bottom: 6px;\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: .05em;\n  text-transform: uppercase;\n}\n\n.account-org-list-row {\n  display: flex;\n  min-height: 48px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.account-org-list-row:last-child { border-bottom: 0; }\n\n.account-org-person { display: flex; min-width: 0; align-items: center; gap: 9px; }\n.account-org-person-avatar { width: 26px; height: 26px; border-radius: 50%; font-size: 10px; }\n.account-org-person-avatar--invite { color: var(--color-text-secondary); }\n.account-org-person > div:last-child { display: grid; min-width: 0; gap: 1px; }\n.account-org-person strong { overflow: hidden; font-size: 12px; font-weight: 520; text-overflow: ellipsis; white-space: nowrap; }\n.account-org-person span { color: var(--color-text-secondary); font-size: 10px; }\n\n.account-org-row-actions { display: flex; flex: 0 0 auto; align-items: center; gap: 3px; }\n.account-org-text-action--danger:hover { color: #d98d82; }\n.account-org-text-action:disabled { opacity: .5; cursor: wait; }\n\n.account-org-confirm { display: flex; align-items: center; gap: 1px; }\n.account-org-confirm > span { margin-right: 2px; color: #d98d82; font-size: 10px; }\n.account-org-confirm button:first-of-type { color: #d98d82; }\n\n@media (max-width: 560px) {\n  .account-org-heading { align-items: center; }\n  .account-org-heading p { display: none; }\n  .account-org-invite { flex-direction: column; }\n  .account-org-invite button { width: 100%; }\n  .account-org-list-row { align-items: flex-start; flex-direction: column; gap: 7px; padding: 9px 0; }\n  .account-org-row-actions { width: 100%; justify-content: flex-end; }\n  .account-org-name-edit { flex-wrap: wrap; }\n}\n\n.account-usage-note {\n  text-align: center;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  margin-bottom: 12px;\n}\n\n.account-usage-info-banner {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  background: var(--color-bg-secondary, rgba(255, 255, 255, 0.05));\n  border-radius: 8px;\n  padding: 10px 14px;\n  margin-bottom: 12px;\n  line-height: 1.4;\n}\n\n.account-chart-tooltip-date {\n  font-size: 10px;\n  color: var(--color-text-secondary);\n}\n\n.account-chart-tooltip-amount {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n/* ===================================\n   Credits & Coupon Section\n   =================================== */\n\n.account-credits-balance {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 0 24px;\n  border-bottom: 1px solid var(--color-border-input);\n  margin-bottom: 14px;\n}\n\n.account-credits-value {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 36px;\n  font-weight: 400;\n  color: var(--color-text-primary);\n  line-height: 1;\n}\n\n.account-credits-label {\n  margin-top: 6px;\n  font-size: 11px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--color-text-secondary);\n}\n\n.account-coupon-form {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.account-coupon-form input {\n  flex: 1;\n  padding: 10px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 2px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-family: inherit;\n  letter-spacing: 0.08em;\n  transition: border-color 0.15s ease;\n}\n\n.account-coupon-form input:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.account-coupon-form input::placeholder {\n  color: var(--color-text-secondary);\n  letter-spacing: normal;\n}\n\n.account-coupon-form input:disabled {\n  opacity: 0.5;\n}\n\n.account-coupon-form button {\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 2px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  white-space: nowrap;\n}\n\n.account-coupon-form button:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.account-coupon-form button:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.account-coupon-message {\n  margin-top: 10px;\n  padding: 8px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 2px;\n}\n\n.account-coupon-message-success {\n  color: var(--color-text-primary);\n  background: var(--color-bg-user-bubble);\n  border: 1px solid var(--color-border-input);\n}\n\n.account-coupon-message-error {\n  color: var(--color-status-error-text);\n  background: var(--color-status-error-tint);\n  border: 1px solid var(--color-status-error-border);\n}\n\n/* ===================================\n   Payment Method Modal\n   =================================== */\n\n.account-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  z-index: 2100;\n}\n\n.account-modal-card {\n  width: min(420px, 100%);\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  animation: accountModalIn 0.15s ease;\n}\n\n@keyframes accountModalIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.account-modal-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  text-align: center;\n}\n\n.account-modal-desc {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n  text-align: center;\n}\n\n.account-modal-desc strong {\n  color: var(--color-text-primary);\n  font-weight: 600;\n}\n\n.account-modal-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.account-modal-primary,\n.account-modal-secondary {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 2px;\n  font-family: inherit;\n  font-size: 14px;\n  cursor: pointer;\n  transition: filter 0.15s ease, background 0.15s ease;\n}\n\n.account-modal-primary {\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n  font-weight: 600;\n}\n\n.account-modal-primary:hover:not(:disabled) {\n  filter: brightness(0.96);\n}\n\n.account-modal-primary:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.account-modal-secondary {\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.account-modal-secondary:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.account-modal-secondary:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* Credits Actions Row */\n.account-credits-actions-row {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.account-credits-buy-btn {\n  padding: 8px 16px;\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n  border: 1px solid var(--color-accent-base);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.account-credits-buy-btn:hover {\n  filter: brightness(0.96);\n}\n\n/* Auto-Reload Settings */\n.account-auto-reload {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--color-border-input);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.account-auto-reload-toggle {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.account-toggle-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--color-text-primary);\n  cursor: pointer;\n}\n\n.account-toggle-label input[type=\"checkbox\"] {\n  accent-color: var(--color-accent-base);\n}\n\n.account-auto-reload-desc {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  margin-left: 24px;\n}\n\n.account-auto-reload-config {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-left: 24px;\n}\n\n.account-auto-reload-select {\n  padding: 4px 8px;\n  font-family: inherit;\n  font-size: 13px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-primary);\n}\n\n/* Switch to Credits */\n.account-switch-credits {\n  border: 1px solid var(--color-border-input);\n  padding: 16px;\n}\n\n.account-switch-desc {\n  margin: 0 0 12px;\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  line-height: 1.45;\n}\n\n.account-switch-btn {\n  padding: 8px 16px;\n  background: transparent;\n  color: var(--color-accent-base);\n  border: 1px solid var(--color-accent-base);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.account-switch-btn:hover:not(:disabled) {\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n}\n\n.account-switch-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Credit Purchase History */\n.account-credit-history {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.account-credit-history-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.account-credit-history-row:last-child {\n  border-bottom: none;\n}\n\n.account-credit-history-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.account-credit-history-source {\n  font-size: 13px;\n  color: var(--color-text-primary);\n  text-transform: capitalize;\n}\n\n.account-credit-history-date {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n}\n\n.account-credit-history-amount {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n/* ===================================\n   Email Preferences\n   =================================== */\n\n.account-email-pref-note {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  line-height: 1.5;\n  margin: 8px 0 0 0;\n}\n\n.account-email-pref-link {\n  color: var(--color-text-primary);\n  text-decoration: underline;\n}\n\n/* ===================================\n   Referral Section\n   =================================== */\n\n.account-referral-desc {\n  font-size: 14px;\n  color: var(--color-text-secondary);\n  margin: 0 0 16px;\n  line-height: 1.5;\n}\n\n.account-referral-link-box {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.account-referral-link-input {\n  flex: 1;\n  padding: 10px 12px;\n  font-size: 13px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 2px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-family: monospace;\n  cursor: text;\n}\n\n.account-referral-copy-btn {\n  padding: 10px 18px;\n  font-size: 13px;\n  font-weight: 500;\n  border: none;\n  border-radius: 2px;\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  cursor: pointer;\n  white-space: nowrap;\n  min-width: 72px;\n}\n\n.account-referral-copy-btn:hover {\n  opacity: 0.85;\n}\n\n.account-referral-code-display {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  margin-bottom: 16px;\n}\n\n.account-referral-code-display strong {\n  font-family: monospace;\n  letter-spacing: 1px;\n  color: var(--color-text-primary);\n}\n\n.account-referral-stats {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 16px;\n  padding: 12px 0;\n  border-top: 1px solid var(--color-border-input);\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.account-referral-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n\n.account-referral-stat-value {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.account-referral-stat-label {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  margin-top: 2px;\n}\n\n.account-referral-invite-form {\n  display: flex;\n  gap: 8px;\n}\n\n.account-referral-invite-form input {\n  flex: 1;\n  padding: 10px 12px;\n  font-size: 13px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 2px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-family: inherit;\n}\n\n.account-referral-invite-form input:focus {\n  outline: none;\n  border-color: var(--color-accent-base);\n}\n\n.account-referral-invite-form button {\n  padding: 10px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  border: 1px solid var(--color-border-input);\n  border-radius: 2px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.account-referral-invite-form button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ── Subscription Plan Cards ── */\n.subscription-plans {\n  display: flex;\n  gap: 12px;\n  margin-top: 4px;\n}\n\n.subscription-plan-card {\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  padding: 20px 16px;\n  background: var(--color-bg-canvas-surface);\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.subscription-plan-card:hover {\n  border-color: color-mix(in srgb, var(--color-accent-base) 50%, var(--color-border-input));\n}\n\n.subscription-plan-card--active {\n  border-color: var(--color-accent-base);\n  box-shadow: 0 0 0 1px var(--color-accent-base), 0 8px 28px -12px rgba(15, 18, 24, 0.5);\n}\n\n.subscription-plan-card__badge {\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--color-accent-base);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding: 2px 12px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n\n.subscription-plan-card__name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin: 0 0 4px;\n}\n\n.subscription-plan-card__price {\n  display: flex;\n  align-items: baseline;\n  gap: 2px;\n  margin-bottom: 12px;\n}\n\n.subscription-plan-card__amount {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  line-height: 1;\n}\n\n.subscription-plan-card__period {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.subscription-plan-card__features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 16px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.subscription-plan-card__features li {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  line-height: 1.4;\n  padding-left: 16px;\n  position: relative;\n}\n\n.subscription-plan-card__features li::before {\n  content: \"\\2713\";\n  position: absolute;\n  left: 0;\n  color: var(--color-accent-base);\n  font-weight: 600;\n  font-size: 11px;\n}\n\n.subscription-plan-card__features li strong {\n  color: var(--color-text-primary);\n}\n\n.subscription-plan-card__action {\n  display: block;\n  width: 100%;\n  text-align: center;\n  padding: 9px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  border: none;\n  transition: opacity 0.15s;\n}\n\n.subscription-plan-card__action:hover:not(:disabled) {\n  opacity: 0.85;\n}\n\n.subscription-plan-card__action:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.account-referral-badge {\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 2px;\n  font-weight: 500;\n}\n\n.account-referral-badge--pending {\n  color: var(--color-text-secondary);\n  background: var(--color-bg-input);\n}\n\n.account-referral-badge--credited {\n  color: #15803d;\n  background: rgba(21, 128, 61, 0.08);\n}\n\n.subscription-plan-card__action--primary {\n  background: var(--color-accent-base);\n  color: #fff;\n}\n\n.subscription-plan-card__action--current {\n  background: color-mix(in srgb, var(--color-accent-base) 12%, transparent);\n  color: var(--color-accent-base);\n  border: 1px solid color-mix(in srgb, var(--color-accent-base) 30%, transparent);\n  cursor: default;\n}\n\n.subscription-plan-card__action--secondary {\n  background: transparent;\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-primary);\n}\n\n.subscription-plan-card__action--danger {\n  background: transparent;\n  border: 1px solid color-mix(in srgb, #c9302c 40%, var(--color-border-input));\n  color: #c9302c;\n  margin-top: 6px;\n  font-weight: 500;\n  font-size: 11px;\n}\n\n/* Active plan details inside card */\n.subscription-plan-card__details {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 12px;\n  padding: 10px;\n  background: color-mix(in srgb, var(--color-accent-base) 5%, transparent);\n  border: 1px solid color-mix(in srgb, var(--color-accent-base) 15%, transparent);\n  border-radius: 6px;\n}\n\n.subscription-plan-card__detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 11px;\n}\n\n.subscription-plan-card__detail-label {\n  color: var(--color-text-secondary);\n}\n\n.subscription-plan-card__detail-value {\n  color: var(--color-text-primary);\n  font-weight: 600;\n}\n\n.subscription-plan-card__allowance-bar {\n  height: 6px;\n  background: color-mix(in srgb, var(--color-accent-base) 12%, transparent);\n  border-radius: 3px;\n  overflow: hidden;\n  margin-top: 2px;\n}\n\n.subscription-plan-card__allowance-fill {\n  height: 100%;\n  background: var(--color-accent-base);\n  border-radius: 3px;\n  transition: width 0.3s ease;\n}\n\n.subscription-plan-card__cancel-notice {\n  font-size: 11px;\n  color: #e5a000;\n  text-align: center;\n  margin-bottom: 8px;\n}\n\n@media (max-width: 600px) {\n  .subscription-plans {\n    flex-direction: column;\n  }\n}\n\n.account-btn {\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: opacity 0.15s;\n}\n\n.account-btn:hover {\n  opacity: 0.85;\n}\n\n.account-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.account-btn--primary {\n  background: var(--color-accent-base);\n  color: #fff;\n}\n\n.account-btn--secondary {\n  background: transparent;\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-primary);\n}\n\n.account-btn--danger {\n  background: transparent;\n  border: 1px solid #c9302c;\n  color: #c9302c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
